import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import type { Language } from '../types/content';
type LanguageSwitcherProps = {
  variant?: 'light' | 'dark';
  className?: string;
};
const codes: Language[] = ['en', 'es'];
export function LanguageSwitcher({
  variant = 'light',
  className = ''
}: LanguageSwitcherProps) {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const active = language ?? 'en';
  const shell = variant === 'light' ? 'border-ink/10 bg-white/70' : 'border-white/12 bg-white/[0.06]';
  return <div className={`flex items-center gap-0.5 rounded-full border p-1 backdrop-blur ${shell} ${className}`} role="group" aria-label={t.switcher.label} data-id="element-18" data-mp="97qsvhvxrcqb">
      {codes.map(code => {
      const isActive = active === code;
      return <button key={code} type="button" onClick={() => setLanguage(code)} aria-pressed={isActive} className={`relative rounded-full px-3 py-1.5 text-[12px] font-semibold uppercase tracking-wide transition-colors duration-300 ${isActive ? 'text-white' : variant === 'light' ? 'text-ink/55 hover:text-ink' : 'text-white/55 hover:text-white'}`} data-id="element-19" data-mp="i988kz5flceh">
            {isActive && <motion.span layoutId={`lang-pill-${variant}`} className="absolute inset-0 rounded-full bg-brand" transition={{
          duration: 0.35,
          ease: [0.22, 1, 0.36, 1]
        }} aria-hidden="true" data-id="element-20" data-mp="23m27glz6hk4z" />}
            <span className="relative" data-id="element-21" data-mp="2wb96rn6gidra">{code === 'en' ? t.switcher.en : t.switcher.es}</span>
          </button>;
    })}
    </div>;
}